module.exports = __webpack_public_path__ + "img/pink_check_mark.8a4c6f6f.png";